import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5438_9944)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M24.25 12C24.25 18.6274 18.8774 24 12.25 24C5.62258 24 0.25 18.6274 0.25 12C0.25 5.37258 5.62258 0 12.25 0C18.8774 0 24.25 5.37258 24.25 12ZM6.58249 13.5711L6.64702 14.7466C6.65124 14.8267 6.68125 14.902 6.73189 14.9637C6.79577 15.0411 6.89982 15.1532 7.04848 15.2849L7.07251 15.3061C7.76093 15.9066 9.35249 16.8875 12.249 16.8875C15.1593 16.8875 16.7395 15.91 17.4249 15.309L17.4248 15.309L17.4534 15.2837L17.4534 15.2837C17.5952 15.157 17.696 15.0486 17.7601 14.9717C17.8154 14.9053 17.8473 14.8229 17.8524 14.7363L17.9164 13.5719C18.3422 13.3383 18.7817 13.0743 18.7817 13.0743C19.4727 12.7 20.244 13.2378 20.2454 14.0266C20.2477 15.3028 19.2505 16.6143 17.9054 17.4408C16.3888 18.3728 14.1248 18.7594 12.25 18.7594C10.3752 18.7594 8.11121 18.3728 6.59456 17.4408C5.24949 16.6143 4.2523 15.3033 4.25464 14.0266C4.25605 13.2378 5.02727 12.7 5.71832 13.0743C5.71832 13.0743 6.15708 13.3377 6.58249 13.5711ZM17.1553 5.43398C15.9663 5.29741 15.1735 5.22913 12.2495 5.22913C9.74078 5.22913 8.51807 5.32001 7.34366 5.43398C6.79467 5.48719 6.35679 5.90491 6.39711 6.45731L6.83505 12.4231C6.97222 12.4628 7.12181 12.513 7.28958 12.5693C8.16804 12.8641 9.54511 13.3263 12.2494 13.3263C14.9538 13.3263 16.3309 12.8641 17.2093 12.5693C17.3769 12.5131 17.5264 12.4629 17.6634 12.4232L18.1013 6.45731C18.1421 5.90491 17.7028 5.49708 17.1548 5.43398H17.1553Z"
        fill="#11181C"
      />
    </g>
    <defs>
      <clipPath id="clip0_5438_9944">
        <rect width="24" height="24" fill="white" transform="translate(0.25)" />
      </clipPath>
    </defs>
  </svg>
)
